module.exports = __webpack_public_path__ + "static/media/tree-cavity.dd89d89d.jpg";